/**
 * 查询数据为空 显示组件
 */
export default {
  dbl_no_data_title: "The query data is empty. Common reasons are as follows:",
  dbl_no_data_one: "1. The data [Filter condition] is inconsistent;",
  dbl_no_data_two: "2. The query fails because the amount of data is too large and [Categorical dimension] is not selected;",
  dbl_no_data_three: "3. If you still have data problems, please contact @v_blljli.",
	
};